import { NoData } from 'components/generic';

const ErrorPage = () => {
	return (
		<>
			<NoData title='Entry Restricted' description='This payment link might have expired! Please contact Admin Team.' />
		</>
	);
};

export default ErrorPage;
